<script setup lang="ts">
// Histórico de apostas do Minha Conta V2 (ENG-362).
// Figma: mobile 19771:42239 / desktop 19771:52430.
// Dados reais: mesma API da página antiga pages/user/history/full.vue
// (useWalletStore.getTransactions). Sem "Todos" a pedido do time — só
// Cassino e Esporte fazem sentido pra extrato de apostas.
// `initialTab` pré-seleciona a filter tab — usado pelas rotas antigas
// /user/history/casino e /user/history/sports (ENG-362).
interface Props {
  initialTab?: 'casino' | 'sports';
}

const props = defineProps<Props>();

const FILTERS = [
  { key: 'casino', label: 'Cassino' },
  { key: 'sports', label: 'Esporte' },
];
</script>

<template>
  <UserV2HistoryTransactionsList
    :filters="FILTERS"
    :initial-filter="props.initialTab"
  />
</template>
